import Splide from '@splidejs/splide';

const slider = document.querySelector('.reviews-slider__slider');

if( slider ) {
    var splide = new Splide( slider , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        focus: 'center',
        start: 1,
        gap: '20%',
        padding: '30%',
        perPage: 1,
        perMove: 1,
        breakpoints: {
            768: {
                gap: '10%',
                padding: '10%',
            },
        }
    });
    splide.mount();
}